import { render } from "./RecordHistory.vue?vue&type=template&id=153ff2d6&scoped=true"
import script from "./RecordHistory.vue?vue&type=script&lang=js"
export * from "./RecordHistory.vue?vue&type=script&lang=js"

import "./RecordHistory.vue?vue&type=style&index=0&id=153ff2d6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153ff2d6"]])

export default __exports__